import { motion } from "framer-motion";
import { EASE, MaskedLine, Micro, Reveal, SlideBody, SlideShell } from "../shared";

const YEARS = [
  {
    year: "2026",
    tag: "Recruit",
    big: "20 VILLE",
    items: ["Selezione e onboarding delle prime ville", "Costiera Amalfitana: Positano, Ravello, Amalfi"],
  },
  {
    year: "2027",
    tag: "Launch",
    items: [
      "La Collection va live",
      "ADV internazionale €20.000",
      "Guest Portal in comodato gratuito",
      "Proof of value: +150% ricavi servizi",
    ],
  },
  {
    year: "2028",
    tag: "Scale",
    big: "100 VILLE",
    items: ["€100K di piano ADV", "≈ €1.000 di investimento per villa", "Il modello scala sull'intera Costiera"],
  },
];

export default function Slide04Roadmap() {
  return (
    <SlideShell theme="ivory" testid="slide-4-roadmap">
      <SlideBody>
        <Reveal>
          <Micro tone="ivory">03 · Roadmap 2026—2028</Micro>
        </Reveal>
        <h2 className="mt-5 font-serif text-4xl leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>
            DA 20 A <em className="italic text-[#997A15]">100 VILLE.</em>
          </MaskedLine>
        </h2>

        <div className="relative mt-16">
          <div className="absolute left-0 right-0 top-[7px] hidden h-px bg-[#0B152C]/15 md:block" />
          <motion.div
            className="absolute left-0 right-0 top-[7px] hidden h-px origin-left bg-[#B8860B] md:block"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.8, delay: 0.4, ease: EASE }}
          />
          <div className="grid gap-12 md:grid-cols-3 md:gap-8">
            {YEARS.map((y, i) => (
              <Reveal key={y.year} delay={0.5 + i * 0.25}>
                <div className="relative md:pt-9">
                  <span className="absolute left-0 top-0 hidden h-[15px] w-[15px] rounded-full border-2 border-[#B8860B] bg-[#FAF7F2] md:block" />
                  <div className="flex items-baseline gap-4">
                    <span className="font-serif text-4xl tracking-tight text-[#0B152C] lg:text-5xl">{y.year}</span>
                    <Micro tone="ivory">{y.tag}</Micro>
                  </div>
                  {y.big && (
                    <div className="tnum mt-4 font-serif text-5xl tracking-tight text-[#B8860B] lg:text-6xl">
                      {y.big}
                    </div>
                  )}
                  <ul className="mt-4 space-y-2.5">
                    {y.items.map((it) => (
                      <li key={it} className="flex items-start gap-3 text-sm leading-relaxed text-[#334155]">
                        <span className="mt-[9px] h-px w-4 shrink-0 bg-[#B8860B]" />
                        {it}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </SlideBody>
    </SlideShell>
  );
}
